"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldSelect = void 0;
var react_1 = __importDefault(require("react"));
var FormFieldSelect_module_scss_1 = __importDefault(require("./FormFieldSelect.module.scss"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var FormFieldSelect = function (props) {
    var placeholder = props.placeholder, items = props.items, setFormValue = props.setFormValue, fieldName = props.fieldName, isError = props.isError, register = props.register;
    var list = react_1.default.useRef(null);
    var container = react_1.default.useRef(null);
    var _a = react_1.default.useState(placeholder), selectValue = _a[0], setSelectValue = _a[1];
    var _b = react_1.default.useState(false), state = _b[0], setState = _b[1];
    var callbackState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).callback.modalState;
    var open = function () { return setState(true); };
    var select = function (event, value) {
        event.stopPropagation();
        setFormValue(fieldName, value);
        setSelectValue(value);
        setState(false);
    };
    react_1.default.useEffect(function () {
        var handleClickOutside = function (event) {
            if (container.current && !container.current.contains(event.target)) {
                setState(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    react_1.default.useEffect(function () {
        if (!callbackState) {
            setSelectValue(placeholder);
        }
    }, [callbackState]);
    return (react_1.default.createElement("div", { className: FormFieldSelect_module_scss_1.default.form_field_select, onClick: open, ref: container },
        react_1.default.createElement("input", __assign({}, register, { className: "".concat(FormFieldSelect_module_scss_1.default.form_field_select__input, " ").concat(isError && selectValue === placeholder ? 'field_error' : ''), autoComplete: "off", type: "text", value: selectValue === placeholder ? '' : selectValue, placeholder: placeholder, readOnly: true })),
        state ? (react_1.default.createElement("ul", { className: FormFieldSelect_module_scss_1.default.form_field_select__list, ref: list }, items.map(function (item) {
            return (react_1.default.createElement("li", { className: FormFieldSelect_module_scss_1.default.form_field_select__item, key: item, onClick: function (event) { return select(event, item); } }, item));
        }))) : null));
};
exports.FormFieldSelect = FormFieldSelect;
